import { Cards } from "@/components/Cloud/Molecules/Image/ImageList/Card/ImageIconCard.model";

export const InvertOrderName = [
    Cards.cpanel
]